import { httpApi } from "./http.api";

export const getAllProducts = (currentPage: any, data: any): Promise<any> =>
  httpApi
    .get<any>(`products?page=${currentPage}`, { params: data })
    // .get<any>(`products?page=1&search=`)
    .then(({ data }: any) => data);
export const getProductVariants = (id: any, currentPage: any): Promise<any> =>
  httpApi
    .get<any>(`product-variants/${id}/${currentPage}`)
    .then(({ data }: any) => data);

export const getProductViews = (id: any): Promise<any> =>
  httpApi.get<any>("product-views/" + id).then(({ data }: any) => data);

export const getPrintMethods = (): Promise<any> =>
  httpApi.get<any>("print-methods").then(({ data }: any) => data);

export const getPrintMethod = (id: any): Promise<any> =>
  httpApi.get<any>("print-methods/" + id).then(({ data }: any) => data);

export const addProductView = (data: any): Promise<any> =>
  httpApi.post<any>("product-views", data).then(({ data }: any) => data);

export const deleteProductView = (id: any): Promise<any> =>
  httpApi.delete<any>("product-views/" + id).then(({ data }: any) => data);

export const updateProductView = (id: any, data: any): Promise<any> =>
  httpApi.put<any>("product-views/" + id, data).then(({ data }: any) => data);

export const getProductView = (id: any): Promise<any> =>
  httpApi.get<any>("product-views/" + id).then(({ data }: any) => data);

export const getProductViewByViewId = (
  id: any,
  productViewId: any
): Promise<any> =>
  httpApi
    .get<any>("product-views/" + id + "/" + productViewId)
    .then(({ data }: any) => data);

export const syncProduct = (): Promise<any> =>
  httpApi
    .get<any>("shopify/sync-shopify-product")
    .then(({ data }: any) => data);

export const getProductVariantView = (
  productId: any,
  variantId: any,
  viewId: any
): Promise<any> =>
  httpApi
    .get<any>(`product-variant-views/${productId}/${variantId}/${viewId}`)
    .then(({ data }: any) => data);

export const getProductVariantViews = (
  productId: any,
  variantId: any
): Promise<any> =>
  httpApi
    .get<any>(`product-variant-views/${productId}/${variantId}`)
    .then(({ data }: any) => data);

export const deleteVariantViewImage = (variantViewId: any): Promise<any> =>
  httpApi
    .delete<any>(`product-variant-views/${variantViewId}`)
    .then(({ data }: any) => data);

export const getDesigns = (currentPage: any, data: any): Promise<any> =>
  httpApi
    .get<any>(`design?page=${currentPage}`, { params: data })
    .then(({ data }: any) => data);

export const getDesignsView = (designId: any): Promise<any> =>
  httpApi
    .get<any>(`design/designView/${designId}`)
    .then(({ data }: any) => data);

export const getProduct = (id: any): Promise<any> =>
  httpApi.get<any>(`products/${id}`);

export const updateProductAll = (ids: any, name: any): Promise<any> =>
  httpApi
    .put<any>(`products/`, { ids: ids, name: name })
    .then(({ data }: any) => data);

export const getPrintMethodDetails = (id: any): Promise<any> =>
  httpApi.get<any>("front/print-method/" + id).then(({ data }: any) => data);
